module.exports = __webpack_public_path__ + "img/thumb_2019-04.084943d2.jpg";